import React from 'react';
import { Icon } from '@eventbrite/marmalade';
import type { IntlShape } from 'react-intl';
import { ArrowLeftIcon, ArrowRightIcon } from '@/components/_shared/Icons';
import styles from './CarouselControls.module.scss';

type CarouselControlsProps = {
  canScrollNext: boolean;
  canScrollPrev: boolean;
  formatMessage: IntlShape['formatMessage'];
  onNext: () => void;
  onPrev: () => void;
};

export const CarouselControls = ({
  canScrollNext,
  canScrollPrev,
  formatMessage,
  onNext,
  onPrev,
}: CarouselControlsProps) => {
  const previousLabel = formatMessage({
    id: 'Previous organizer event',
  });
  const nextLabel = formatMessage({
    id: 'Next organizer event',
  });

  return (
    <div className={styles.controls}>
      <button
        aria-label={previousLabel}
        className={styles.controlButton}
        disabled={!canScrollPrev}
        onClick={onPrev}
        type="button"
      >
        <Icon size="xsmall">
          <ArrowLeftIcon />
        </Icon>
        <span className={styles.accessibleText}>{previousLabel}</span>
      </button>
      <button
        aria-label={nextLabel}
        className={styles.controlButton}
        disabled={!canScrollNext}
        onClick={onNext}
        type="button"
      >
        <Icon size="xsmall">
          <ArrowRightIcon />
        </Icon>
        <span className={styles.accessibleText}>{nextLabel}</span>
      </button>
    </div>
  );
};
